const RoutesInstance = {
    login: "/auth/login",
    dashboard: "/dashboard",

    brands: "/dashboard/brands",
    editBrand: "/dashboard/brands/:id",
    createBrand: "/dashboard/brands/create",

    categories: "/dashboard/categories",
    editCategory: "/dashboard/categories/:id",
    createCategory: "/dashboard/categories/create",

    tags: "/dashboard/tags",
    editTag: "/dashboard/tags/:id",
    createTag: "/dashboard/tags/create",

    platforms: "/dashboard/platforms",
    editPlatform: "/dashboard/platforms/:id",
    createPlatform: "/dashboard/platforms/create",

    articles: "/dashboard/articles",
    editArticle: "/dashboard/articles/:id",
    createArticle: "/dashboard/articles/create",

    products: "/dashboard/products",
    editProduct: "/dashboard/products/:id",
    createProduct: "/dashboard/products/create",

    gallery: "/dashboard/gallery",
    editGallery: "/dashboard/gallery/:id",
    createGallery: "/dashboard/gallery/create",

    excel: "/dashboard/excel",
};

export default RoutesInstance;
